"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIDDocumentLite = void 0;
const did_ethr_resolver_1 = require("@ew-did-registry/did-ethr-resolver");
class DIDDocumentLite {
    /**
     * @param {string} did - entity identifier, which is associated with DID Document
     * @param {IResolver} resolver - resolver exposing read functionality of DID Document
     */
    // eslint-disable-next-line no-useless-constructor
    constructor(did, resolver) {
        this.did = did;
        this.resolver = resolver;
    }
    /**
     * Returns the current owner for certain DID.
     * If owner not assigned explicitly than identity is the owner of itself
     *
     * @param {string} did
     * @returns {Promise<string>}
     */
    getController(did = this.did) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.resolver.identityOwner(did);
        });
    }
    /**
     * Checks if the delegate is present for a particular DID.
     *
     * @param {DelegateTypes} delegateType
     * @param {string} delegateDID
     * @param {string} did
     * @returns {Promise<boolean>}
     */
    isValidDelegate(delegateType, delegateDID, did = this.did) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.resolver.validDelegate(did, delegateType, delegateDID);
        });
    }
    /**
     * Finds first attribute which satisfies filter
     *
     * @param selector {{ [attr: string]: { [prop: string]: string } }} object used
     *  to describe part of the document. `attr` is one of standard DID attributes
     *  like `publicKey`, `serviceEndpoints` or `authentication` and `prop` - properties
     *  of this attribute such as `type` or `value`
     * @param did {string}
     *
     * @returns {object | null}
     */
    readAttribute(selector, did = this.did) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.resolver.readAttribute(did, selector);
        });
    }
    /**
     * Returns document of the given `did`
     *
     * @param did {string}
     */
    read(did = this.did) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.resolver.read(did);
        });
    }
    ownerPubKey(did = this.did) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.resolver.readOwnerPubKey(did);
        });
    }
    lastBlock(did) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.resolver.lastBlock(did);
        });
    }
    readFromBlock(did, from) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.resolver.readFromBlock(did, from);
        });
    }
    fromLogs(logs, did = this.did) {
        return (0, did_ethr_resolver_1.documentFromLogs)(did, logs);
    }
}
exports.DIDDocumentLite = DIDDocumentLite;
//# sourceMappingURL=index.js.map